class Registration {
  username = '';
  email = '';
  password = '';
  passwordRepeat = '';
  captchaToken = '';
  country = '';
  workingAt = '';
  howDidYouHear = '';
  occupation = null;
  

  contactJobOpportunities = false;
  contactFutureEvents = false;
  publishOnCtfTime = false;
  
  isHackazonUser = true;
  isSpaceRaceUser = true;
  isRegistered = true;

  public constructor(init?: Partial<Registration>) {
    Object.assign(this, init);
  }
}

export default Registration;